import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import map from 'lodash/map';

import MenuItem from './MenuItem';
import styles from './Menu.module.css';

const delayCall = (callback) => {
  setTimeout(() => {
    callback();
  }, 300);
};

const MobileMenu = ({
  isOpen,
  title,
  options,
  selected,
  checkSelected,
  closeMenu,
  onClick,
}) => {
  const menuRef = useRef();
  const [animation, setAnimation] = useState(false);

  const handleCloseMenu = () => {
    setAnimation(false); // slide down animation
    delayCall(closeMenu);
  };
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      handleCloseMenu();
    }
  };
  const handleClickItem = (id, name) => {
    setAnimation(false); // slide down animation
    delayCall(() => onClick(id, name));
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickOutside, false);
      delayCall(() => setAnimation(true)); // slide up animation
      disableBodyScroll(menuRef.current);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div
          className={`${styles.menu} ${animation ? styles.animation : ''}`}
          ref={menuRef}
        >
          <div className={styles.header}>
            <h1>{title}</h1>
            <button
              type="button"
              className={styles.closeButton}
              onClick={handleCloseMenu}
            >
              <i className="far fa-times" />
            </button>
          </div>
          <ul>
            {map(options, (option) => {
              const { id, name, children } = option;
              return (
                <MenuItem
                  key={id}
                  id={id}
                  name={name}
                  submenu={children}
                  selected={selected}
                  checkSelected={checkSelected}
                  onClickItem={handleClickItem}
                />
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checkSelected: PropTypes.bool,
  closeMenu: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

MobileMenu.defaultProps = {
  selected: null,
  checkSelected: false,
};

export default MobileMenu;
